"use strict";
const COINGECKO_AVAX_LIST = "https://tokens.coingecko.com/avalanche/all.json";
export const DEFAULT_INACTIVE_LIST_URLS = [COINGECKO_AVAX_LIST];
